'use client'

import ICasino, { getMinBet } from '../../models/ICasino'
import { Divider, Grid, Stack } from '@mui/material';

import CasinoMinBetInSearch from './CasinoMinBetInSearch';
import { useAppState } from '../../reduxish/appState';


/**
 * This is a React functional component that renders the casino data in the list of casinos.
 * @returns {JSX.Element}
 */
export default function CasinoMinBetsInSearch({ casino }: { casino: ICasino }) {
    const { state: { userPreferences: { displayCraps, displayBlackjack, displayRoulette } } } = useAppState();

    return (
        <>
            <Grid sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }} size={8}>
                <Stack direction={'column'}
                >
                    {displayCraps && <CasinoMinBetInSearch minBet={getMinBet(casino, 'craps')} minBetType='Craps' />}
                    {displayBlackjack && <CasinoMinBetInSearch minBet={getMinBet(casino, 'blackjack')} minBetType='Blackjack' />}
                    {displayRoulette && <CasinoMinBetInSearch minBet={getMinBet(casino, 'roulette')} minBetType='Roulette' />}
                </Stack>
            </Grid>
            <Grid sx={{ display: { xs: 'none', md: 'flex' }, height: 80, justifyContent: 'flex-end' }} container size={8}>
                <Stack
                    divider={<Divider orientation="vertical" flexItem />}
                    direction='row'
                    spacing={2}
                    sx={{ alignItems: 'center' }}
                >
                    {displayCraps && <CasinoMinBetInSearch minBet={getMinBet(casino, 'craps')} minBetType='Craps' />}
                    {displayBlackjack && <CasinoMinBetInSearch minBet={getMinBet(casino, 'blackjack')} minBetType='Blackjack' />}
                    {displayRoulette && <CasinoMinBetInSearch minBet={getMinBet(casino, 'roulette')} minBetType='Roulette' />}
                </Stack>
            </Grid>
        </>
    );
}
